import { Stack, type SxProps } from '@mui/material';

import Chip, { type Props as ChipProps } from '../Chip';

interface Props extends ChipProps {
  items: string[];
  sx?: SxProps;
}

export default function Chips(props: Props) {
  const { items, sx, ...rest } = props;

  if (!Array.isArray(items) || items.length === 0) {
    return false;
  }

  return (
    <Stack
      direction="row"
      sx={[
        {
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 0.5,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {items.map((item) => (
        <Chip
          key={item}
          label={item}
          {...rest}
        />
      ))}
    </Stack>
  );
}
